import React from 'react';
import { useSelector } from 'react-redux';
import VendorBidOfferAndDemandTable from '../VendorBidOfferAndDemandTable';

const VendorOtherOfferBidTable = () => {
  const { selectedVendor } = useSelector((state) => state.vendorDetailsReducer);

  return (
    <div>
      <VendorBidOfferAndDemandTable
        filter={[
          {
            key: 'bidType',
            value: 'OFFER',
            type: 'STRING',
            op: 'EQ',
          },
          {
            key: 'bidder',
            value: selectedVendor?.id,
            type: 'INT',
            op: 'EQ',
          },
        ]}
      />
    </div>
  );
};

export default VendorOtherOfferBidTable;
